import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../layout/header'
import Footer from '../layout/footer'

var bnr4 = require('./../../images/banner/bnr4.jpg');
//var bg8 = require('./../../images/background/bg8.jpg');

class shortTitleSeparators extends Component {


    render() {
        return (
            <>
                <Header />

                <div className="page-content bg-white">
                    
					<div className="dlab-bnr-inr overlay-black-middle text-center bg-pt"  style={{ backgroundImage: "url(" + bnr4 + ")" }}>
                        <div className="container">
                            <div className="dlab-bnr-inr-entry">
								<h1 className="text-white">Separators</h1>
								<div className="breadcrumb-row">
									<ul className="list-inline">
										<li><Link to="/">Home</Link></li>
										<li>Element</li>
										<li>Separators</li>
									</ul>
								</div>
							</div>
                        </div>
                    </div>
					
					<div className="bg-white">
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-center">
										<div className=" clearfix">
											<h4>Title separator style 1</h4>
										</div>
										<div className="dlab-separator bg-primary"></div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
										since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className=" clearfix ">
											<h4>Title separator style 2</h4>
										</div>
										<div className="dlab-separator bg-primary"></div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-right">
										<div className=" clearfix ">
											<h4>Title separator style 3</h4>
										</div>
										<div className="dlab-separator bg-primary"></div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-center">
										<div className=" clearfix">
											<h4>Title separator style 4</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-liner"></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className=" clearfix">
											<h4>Title separator style 5</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-liner"></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-right">
										<div className=" clearfix">
											<h4>Title separator style 6</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-liner"></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-center">
										<div className=" clearfix">
											<h4>Title separator style 7</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-skew"></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className=" clearfix">
											<h4>Title separator style 8</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-skew"></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-right">
										<div className=" clearfix">
											<h4>Title separator style 9</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-skew"></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-center">
										<div className="clearfix">
											<h4>Title separator style 10</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator style-icon"><i className="fa fa-leaf"></i></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className=" clearfix">
											<h4>Title separator style 11</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator style-icon"><i className="fa fa-leaf"></i></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-right">
										<div className=" clearfix">
											<h4>Title separator style 12</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator style-icon"><i className="fa fa-leaf"></i></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-center">
										<div className=" clearfix">
											<h4>Title separator style 13</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator text-primary style-icon"><i className="fa fa-leaf"></i></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className=" clearfix">
											<h4>Title separator style 14</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary text-white style-icon"><i className="fa fa-leaf"></i></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-white content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-right">
										<div className=" clearfix">
											<h4>Title separator style 15</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-icon text-white radius-sm"><i className="fa fa-leaf"></i></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
						<div className="section-full bg-gray content-inner">
							<div className="container">
								<div className="row">
									<div className="col-lg-12 text-center">
										<div className=" clearfix">
											<h4>Title separator style 16</h4>
										</div>
										<div className="dlab-separator-outer ">
											<div className="dlab-separator bg-primary style-icon text-white radius-xl"><i className="fa fa-leaf"></i></div>
										</div>
										<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever 
											since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book has survived.</p>
									</div>
									<div className="section-content"></div>
								</div>
							</div>
						</div>
					</div>
					
                </div>

                <Footer />
            </>
        )
    }
}

export default shortTitleSeparators;